import React from "react";
import { Box } from "@mui/material";

// Default container for a worklist page; fills viewport so inner content can expand to full height.
// Pass fillAvailableHeight when this is nested inside another flex layout (e.g. Coder View V2)
// so it shrinks to the space its parent actually allocated instead of forcing a full extra viewport.
const DefaultWrapper = (props: any) => {
    return (
        <Box sx={{
            height: '100%',
            width: '100%',
            minHeight: props.fillAvailableHeight ? 0 : '100vh',
            display: 'flex',
            flexDirection: 'column',
            padding: 0,
            margin: 0,
        }}>
            {props.children}
        </Box>
    );
}

export default DefaultWrapper;